import React from 'react';
import Typo from '../typo';
import Media from '../media';
import Button from '../button';

const NoDataFound = ({
  noDataThumb,
  noDataTitle,
  noDataCaption,
  noDataCta,
  onClick,
  isLoggedIn
}) => {
  return (
    <>
      <div className={`si-noData__wrap ${!isLoggedIn ? 'si-noData__wrap--loggedOutUser' : ''}`}>
        {noDataTitle && (
          <Typo className='si-noData__title' component={'span'}>
            {noDataTitle}
          </Typo>
        )}
        {noDataCaption && (
          <Typo className='si-noData__caption' component={'p'}>
            {noDataCaption}
          </Typo>
        )}
        {noDataThumb && (
          <div className='si-noData__thumb'>
            <Media imgSrc={noDataThumb} imgAlt={noDataTitle} />
          </div>
        )}
        {noDataCta ? (
          <div className='si-noData__cta'>
            <Button
              variant={'primary'}
              btnCls='si-btn si-btn__link'
              btnText={noDataCta}
              onClick={onClick}
            >
              {noDataCta}
            </Button>
          </div>
        ) : (
          ''
        )}
      </div>
    </>
  );
};

export default NoDataFound;
